import * as LucideIcons from "lucide-react"

export function GithubIcon({ className = "button-icon" }) {
  return (
    <svg className={className} viewBox="0 0 16 16" aria-hidden="true">
      <path
        fill="currentColor"
        d="M8 0C3.58 0 0 3.67 0 8.2c0 3.63 2.29 6.7 5.47 7.79.4.08.55-.18.55-.4 0-.2-.01-.85-.01-1.54-2.01.38-2.53-.5-2.69-.96-.09-.24-.48-.96-.82-1.15-.28-.16-.68-.55-.01-.56.63-.01 1.08.59 1.23.84.72 1.24 1.87.89 2.33.68.07-.53.28-.89.51-1.09-1.78-.21-3.64-.91-3.64-4.04 0-.89.31-1.62.82-2.19-.08-.21-.36-1.04.08-2.16 0 0 .67-.22 2.2.84A7.42 7.42 0 0 1 8 4c.68 0 1.36.09 2 .28 1.53-1.06 2.2-.84 2.2-.84.44 1.12.16 1.95.08 2.16.51.57.82 1.3.82 2.19 0 3.14-1.87 3.83-3.65 4.04.29.26.54.75.54 1.52 0 1.09-.01 1.98-.01 2.24 0 .22.15.48.55.4A8.1 8.1 0 0 0 16 8.2C16 3.67 12.42 0 8 0Z"
      />
    </svg>
  )
}

export function StackInsightIcon({ className = "feature-icon" }) {
  return <LucideIcons.Layers3 className={className} aria-hidden="true" strokeWidth={1.7} />
}

export function ConfidenceIcon({ className = "feature-icon" }) {
  return <LucideIcons.ShieldCheck className={className} aria-hidden="true" strokeWidth={1.7} />
}

export function SupportIcon({ className = "feature-icon" }) {
  return <LucideIcons.Headset className={className} aria-hidden="true" strokeWidth={1.7} />
}

export function SourceIcon() {
  return <LucideIcons.FolderTree aria-hidden="true" strokeWidth={1.7} />
}

export function StackNavIcon() {
  return <LucideIcons.Layers3 aria-hidden="true" strokeWidth={1.7} />
}

export function DomainsNavIcon() {
  return <LucideIcons.Map aria-hidden="true" strokeWidth={1.7} />
}

export function ConceptNavIcon() {
  return <LucideIcons.Star aria-hidden="true" strokeWidth={1.7} />
}

export function TeamNavIcon() {
  return <LucideIcons.UsersRound aria-hidden="true" strokeWidth={1.7} />
}

export function SettingsIcon({ className = "nav-icon" }) {
  return <LucideIcons.Settings2 className={className} aria-hidden="true" strokeWidth={1.7} />
}

export function ChevronDownIcon({ className = "nav-icon" }) {
  return <LucideIcons.ChevronDown className={className} aria-hidden="true" strokeWidth={1.9} />
}

export function RepositoriesIcon() {
  return <LucideIcons.ListTree aria-hidden="true" strokeWidth={1.7} />
}

export function AccountIcon() {
  return <LucideIcons.CircleUserRound aria-hidden="true" strokeWidth={1.7} />
}

export function FileGlyph({ folder, className = "glyph-icon" }) {
  if (folder) return <LucideIcons.Folder className={className} aria-hidden="true" strokeWidth={1.7} />

  return <LucideIcons.FileText className={className} aria-hidden="true" strokeWidth={1.7} />
}

export function BackArrowIcon({ className = "nav-icon" }) {
  return <LucideIcons.ArrowLeft className={className} aria-hidden="true" strokeWidth={1.9} />
}

export function CloseIcon({ className = "nav-icon" }) {
  return <LucideIcons.X className={className} aria-hidden="true" strokeWidth={1.9} />
}

export function ForwardArrowIcon({ className = "button-icon" }) {
  return <LucideIcons.ArrowRight className={className} aria-hidden="true" strokeWidth={1.9} />
}
